import styled from 'styled-components';
import PageContent from '../../components/PageContent';
import { useParams } from 'react-router';
import { getReportDetail, getConversationList } from '../../api/Report';
import {useState, useEffect, createRef, useMemo} from 'react';
import { message, Spin, Descriptions, Button, Timeline, Grid } from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useSelector } from 'react-redux';
import {
  currentToken,
  isCompany,
  currentUser,
} from '../../features/user/userSlice';
import BG from '../../assets/images/report-list-bg.png';
import { DateIcon, UserIcon, HotIcon, TypeIcon } from '../../icons';
import TimelineItem from 'antd/lib/timeline/TimelineItem';
import TimeLineContent from './components/TimeLineContent';
import DialogueReply from './components/DialogueReply';

import TimeLineAvater from './components/TimeLineAvater';
import RewardBounty from '../../components/reward-bounty';
import { getAuthorWallet } from '../../api/Auhtor';
import MarkdownIt from "markdown-it";
import {AlertTag} from "../../components/AlertTag";
import _isEmpty from "lodash/isEmpty";

// import { useReducer } from 'react';
const mdParser = new MarkdownIt();
const {useBreakpoint} = Grid

const ReportDetailContainer = styled.div`
  /* padding-top: 10px; */
  min-height: 500px;
  padding-bottom: 20px;
  color: #4b555e;
  width: 100%;
  max-width: 1200px;
`;
const ReportTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  margin-top: 20px;
  margin-bottom: 20px;
  color: #fff;
`;

const ReportInfo = styled.div`
  display: inline-flex;
  gap: 28px;
  & > h3 {
    margin-right: 10px;
    color: #4b555e;
    font-weight: 400;
    & > img {
      margin-bottom: 2px;
    }
  }
`;

const DescriptionContent = styled.div`
  position: relative;
  font-size: 14px;
  min-height: 50px;
  margin-top: 15px;
  padding-bottom: 30px;
  line-height: 1.7;
  color: #fff;
  ${(props) =>
    props.hasNext &&
    `border-bottom: 1px solid rgb(43, 43, 43);padding-bottom: 30px;`}
`;

const MarkDownContainer = styled.div`
  ${(props) => props.hasNext && `border-bottom: 1px solid rgb(43, 43, 43);`}
`;

const DescTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 0;
`;

const CommentContainer = styled.div`
  padding: 20px;
  margin-top: 20px;
  background-color: #0e0e0e;
  border: 1px solid #0e0e0e;
  box-shadow: 0 2px 10px #0e0e0e;
  border-radius: 6px;
  background-image: url(${BG});
  background-repeat: no-repeat;
`;

const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px 0;
`;

const StatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 8px;
  padding-top: 10px;
  @media screen and (max-width: 600px) {
    padding-left: 25px;
  }
`;

const StatusItem = styled.div`
  width: 260px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin-bottom: 16px;
  position: relative;

  @media screen and (max-width: 600px) {
    &:before {
      content: '';
      width: 4px;
      height: 4px;
      border-radius: 5px;
      position: absolute;
      left: -25px;
      top: 50%;
      margin-top: -2px;
      background-color: #6EE6C6;
    }
    & + &:after {
      content: '';
      width: 1px;
      height: 40px;
      position: absolute;
      left: -23.5px;
      bottom: 50%;
      //margin-top: 2.px;
      background-color: #6EE6C6;
    }
  }
`;

const RewardButton = styled.div`
  min-width: 56px;
  line-height: 20px;
  padding: 0 5px;
  /* border-radius: 6px; */
  height: 20px;
  /* background-color: #fff; */
  text-align: center;
  margin-left: 5px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
    color: #6ee6c6;
  }
`;

const Status = styled.div`
  min-width: 56px;
  height: 20px;
  line-height: 20px;
  padding: 0 5px;
  border-radius: 6px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  border: 1px solid;
  box-sizing: border-box;
  margin-left: 8px;

  // background-color: rgba(255,142,0,0.5);
  color: #6ee6c6;

  @media screen and (max-width: 600px) {
    border: 0;
    color: #fff;
    justify-content: flex-start;
  }

    // ${(props) => props.status === 1 && `background-color: rgba(255,142,0,0.5);`}
  // ${(props) => props.status === 2 && `background-color: rgba(24,234,196,0.5);`}

  // ${(props) => props.status === 1 && `color:#FF9500;`}
  // ${(props) => props.status === 2 && `color:#18EAC4;`}

  
  // ${(props) => props.status === 1 && `border:1px soild #FF9500;`}
  // ${(props) => props.status === 2 && `border:1px soild #18EAC4;`}
`;

const ReportInfoContral = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-row-gap: 28px;
`;

const TimeLineContainer = styled.div`
  padding-top: 20px;
  width: 100%;
`;

const AttachmentLink = styled.a`
  color: #fff;
  &:hover,
  &:focus,
  &:visited {
    color: #fff;
  }
`

const getFileName = (url = '') => {
  if (url) {
    const items = url.split('/')
    return items[items.length - 1]
  }
  return url
}

const ReportDetail = (props) => {
  const { t } = useTranslation();
  const { serial_number } = useParams();
  const navigate = useNavigate();
  const token = useSelector(currentToken);
  const _USER = useSelector(currentUser);
  const _isCompany = useSelector(isCompany);
  // const CommentRef = createRef();

  const [reportDetail, setReportDetail] = useState({});
  const [reportAbstract, setReportAbstract] = useState({
    _id: null,
    // title: null,
    company: null,
    author: null,
    date: null,
    // params: null,
    classfication: null,
    level: null,
  });

  const [report_logs, setReportLogs] = useState([]);
  const [Comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isPublish, setIsPublish] = useState(false);
  const [showDialogues, setShowDialogues] = useState(false);
  const [dialogue, setDialogue] = useState([]);

  const [userRewardAddress, setUserRewardAddress] = useState(null);
  const [platformRewardAddress, setPlatformRewardAddress] = useState(null);

  const [whitehatRewards, setWhitehatRewards] = useState('');
  const [platformRewards, setPlatformRewards] = useState('');

  const breakpoint = useBreakpoint();

  const isMobile = useMemo(() => {
    return breakpoint.xs || (breakpoint.sm && !breakpoint.md)
  }, [breakpoint])

  const getTimeline = async (serial_number) => {
    const {code, data} = await getConversationList({serial_number});
    if (code === '10000') {
      setDialogue(data)
    }
  }

  // Reward Modal
  const [ModalVisible, setModalVisible] = useState(false);

  const action_type = {
    //操作类型：0-创建报告，1-审核通过，2-审核拒绝，3-确认报告，4-忽略报告，5-公开报告，6-删除报告（用户仅能删除自己待审核的报告）,7-支付赏金
    0: t('ReportDetail.Status_line.Created report'),
    1: t('ReportDetail.Status_line.Approved report'),
    2: t('ReportDetail.Status_line.Rejected report'),
    3: t('ReportDetail.Status_line.Confirmed report'),
    4: t('ReportDetail.Status_line.Ignored Report'),
    5: t('ReportDetail.Status_line.Published Report'),
    6: t('ReportDetail.Status_line.Deleted Report'),
    7: t('ReportDetail.Status_line.Rewarded Report'),
    8: t('ReportDetail.Status_line.Fixed'),
  };

  const isSameCompany = useMemo(() => {
    return reportDetail.company_id === _USER?.user?.company_id
  }, [reportDetail, _USER])

  const isCoAdmin = useMemo(() => {
    return isSameCompany && _USER?.user?.is_primary === 0
  }, [isSameCompany, _USER])

  const isPrimaryAdmin = useMemo(() => {
    return isSameCompany && _USER?.user?.is_primary === 1
  }, [isSameCompany, _USER])

   const isSubmitter = useMemo(() => {
     return reportDetail.user_id === _USER?.user?.id
   }, [reportDetail, _USER])

  useEffect(() => {
    if (!_isEmpty(reportDetail)) {
      showDialog()
    }
  }, [reportDetail])

  const showDialog = () => {
    if (!_USER || !_USER.user) return setShowDialogues(false);

    if (isPrimaryAdmin || isCoAdmin || isSubmitter) {
      setShowDialogues(true);
    } else {
      setShowDialogues(false);
    }
  };

  const fetchData = async (serial_number, status) => {
    if (status !== 'refresh') {
      setLoading(true);
    }

    try {
      const { data, code, msg } = await getReportDetail(serial_number);

      if (code === '10000') {
        setReportDetail(data.report);
        setDialogue(data.report_timeline);
        setReportAbstract({
          _id: data.report.serial_number,
          // title: data.report.title,
          company: data.report.company_name,
          author: data.report.user?.name,
          date: moment.unix(data.report.created_at).format('YYYY-MM-DD'),
          // params: null,
          classfication: data.report.category
            ? data.report.category.name
            : 'null',
          level: <AlertTag type={data.report.level_id} space={3} />,
        });
        setComments(data.report_comments.list);
        setReportLogs(data.report_logs);
        setIsPublish(data.report.is_publish === 1);
      }else if(code === '50000'){
        message.error(msg);
        function timeout(delay) {
          return new Promise( res => setTimeout(res, delay) );
        }
        await timeout(1000);
        navigate('/reports');
        return;
      }
    } catch (_error) {
      // console.log(_error);
      setError(_error);
      // message.error(error);
      // navigate(-1);
    }
    setLoading(false);
  };

  const refreshData = () => {
    // CommentRef.current.onRefreshData();
    fetchData(
      {
        serial_number,
      },
      'refresh'
    );
  };

  const OpenRewardModal = async () => {
    const res = await getAuthorWallet(serial_number);
    if (res.code === '10000') {
      setUserRewardAddress(res.data.user_address);
      setPlatformRewardAddress(res.data.platform_address);
      setWhitehatRewards(res.data.whitehat_rewards);
      setPlatformRewards(res.data.platform_rewards);
      setModalVisible(true);
    }
  };

  useEffect(() => {
    fetchData({
      serial_number,
    });
  }, [token]);

  // useEffect(() => {
  //   if (!token) {
  //     fetchData({
  //       serial_number,
  //     });
  //   }
  // }, [token]);

  return (
    <ReportDetailContainer>
      <Spin spinning={loading}>
        {loading ? (
          <ReportDetailContainer />
        ) : (
          <ReportDetailContainer>
            <PageContent
              title={
                <>
                  <ReportTitle>{reportDetail.title}</ReportTitle>
                  <ReportInfo>
                    <div>
                      <UserIcon /> {reportDetail.user && reportDetail.user.name}
                    </div>
                    <div>
                      <DateIcon />
                      {moment
                        .unix(reportDetail.created_at)
                        .format('YYYY-MM-DD')}
                    </div>
                    <div>
                      <HotIcon /> {reportDetail.view_count}
                    </div>
                  </ReportInfo>
                </>
              }
            >
              <Descriptions
                title={<DescTitle>{t('ReportDetail.abstract')}</DescTitle>}
                column={{ xs: 1, sm: 2, md: 2 }}
                size={'small'}
                style={{
                  paddingBottom: '20px',
                  borderBottom: '1px solid #2b2b2b',
                }}
              >
                {reportAbstract
                  ? Object.keys(reportAbstract).map((key) => {
                      return (
                        <Descriptions.Item
                          key={key}
                          label={t(`ReportDetail.abstractInfo.${key}`)}
                          labelStyle={{
                            fontSize: '14px',
                            color: '#4b555e',
                            width: isMobile ? '110px' : 'auto'
                          }}
                          contentStyle={{
                            fontSize: '14px',
                            color: '#fff',
                          }}
                        >
                          <span
                            style={{
                              marginLeft: '12px',
                            }}
                          >
                            {reportAbstract[key]}
                          </span>
                        </Descriptions.Item>
                      );
                    })
                  : null}
              </Descriptions>
              <DescTitle
                style={{
                  paddingTop: '20px',
                }}
              >
                {t('ReportDetail.status')}
              </DescTitle>
              <StatusContainer
                style={{
                  borderBottom: '1px solid #2b2b2b',
                }}
              >
                {report_logs.length > 0 ? (
                  report_logs.map((item, index) => {
                    return (
                      <StatusItem key={index}>
                        <span>
                          {moment.unix(item.created_at).format('YYYY-MM-DD')}
                        </span>
                        <Status status={item.action_type}>
                          {action_type[item.action_type]}
                        </Status>
                        {/* {_isCompany &&
                        item.action_type === 3 && reportDetail.company != null &&
                        _USER?.user.id === reportDetail.company.user_id &&
                        reportDetail.reward_bounty === 0 ? (
                          <RewardButton onClick={OpenRewardModal}>
                            Reward
                          </RewardButton>
                        ) : null} */}
                      </StatusItem>
                    );
                  })
                ) : (
                  <StatusItem>No Data</StatusItem>
                )}
              </StatusContainer>
              <DescTitle
                style={{
                  paddingTop: '20px',
                }}
              >
                {t('ReportDetail.description')}
              </DescTitle>
              <DescriptionContent

                style={{
                  borderBottom: '1px solid #2b2b2b',
                }}
                hasNext={isPublish}>
                {reportDetail.description}
              </DescriptionContent>
              {reportDetail.detail ? (
                <>
                  <DescTitle
                    style={{
                      paddingTop: '20px',
                      paddingBottom: '10px',
                    }}
                  >
                    {t('ReportDetail.detail')}
                  </DescTitle>
                  <MarkDownContainer hasNext={reportDetail.solution}>
                    <div dangerouslySetInnerHTML={{__html: mdParser.render(reportDetail.detail)}} className="detail-markdown custom-html-style" />
                  </MarkDownContainer>
                  {reportDetail.solution && (
                    <>
                      <DescTitle
                        style={{
                          paddingTop: '20px',
                        }}
                      >
                        {t('ReportDetail.solution')}
                      </DescTitle>
                      <div style={{
                          paddingBottom: '20px',
                        }}
                        dangerouslySetInnerHTML={{__html: mdParser.render(reportDetail.solution)}}
                        className="detail-markdown custom-html-style" />
                    </>
                  )}
                  {
                    reportDetail.attachments?.length ? (
                        <>
                          <DescTitle
                              style={{
                                paddingTop: '20px',
                                paddingBottom: '10px',
                                borderTop: '1px solid #2b2b2b',
                              }}
                          >
                            {t('ReportDetail.attachments')}
                          </DescTitle>
                          <div
                            style={{
                              paddingBottom: '15px',
                            }}>
                            {
                              reportDetail.attachments.map(attachment => (
                                  <p key={attachment.remote_url}>
                                    <AttachmentLink href={attachment.remote_url} target='_blank'>
                                      <LinkOutlined /> {getFileName(attachment.remote_url)}
                                    </AttachmentLink>
                                  </p>
                              ))
                            }
                          </div>

                        </>
                    ) : null
                  }
                </>
              ) : null}
              {dialogue.length > 0 ? (
                <>
                  <DescTitle
                    style={{
                      paddingTop: '20px',
                      borderTop: '1px solid #2b2b2b',
                    }}
                  >
                    Timeline
                  </DescTitle>
                  <TimeLineContainer>
                    <Timeline>
                      {dialogue.map((item) => {
                        return (
                          <TimelineItem
                            color="#18EAC4"
                            key={item.created_at}
                            dot={
                              // item.action_from ? item.action_from.avatar ? (
                              //   <TimeLineAvater
                              //       avatar={item.action_from.avatar}
                              //   />
                              // ) : null : ''
                                ''
                            }
                          >
                            <TimeLineContent data={item} />
                          </TimelineItem>
                        );
                      })}
                    </Timeline>
                  </TimeLineContainer>
                  {showDialogues ? (
                    <DialogueReply
                      serial_number={serial_number}
                      onRefresh={() => {
                        getTimeline(serial_number);
                      }}
                    />
                  ) : null}
                </>
              ) : null}
            </PageContent>
            {/* <CommentContainer>
              <DescTitle>{t('ReportDetail.comment')}</DescTitle>
              {token ? (
                <ReportComment
                  onRef={CommentRef}
                  CommentData={Comments}
                  _replyNumber={reportDetail.serial_number}
                  refreshData={refreshData}
                />
              ) : (
                <LoginContainer>
                  <Button
                    type="primary"
                    onClick={() => {
                      navigate('/login');
                    }}
                    style={{
                      height: '42px',
                      backgroundColor: '#18EAC4',
                      borderColor: '#18EAC4',
                      color: '#000',
                      borderRadius: '6px',
                    }}
                  >
                    {t('login')}
                  </Button>
                </LoginContainer>
              )}
            </CommentContainer> */}
          </ReportDetailContainer>
        )}
      </Spin>
      <RewardBounty
        visible={ModalVisible}
        setVisible={setModalVisible}
        serial_number={reportDetail.serial_number}
        address={userRewardAddress}
        platformAddress={platformRewardAddress}
        whiteHatRewards={whitehatRewards}
        platformRewards={platformRewards}
        userName={reportDetail?.user?.name}
        refreshData={refreshData}
      />
    </ReportDetailContainer>
  );
};
export default ReportDetail;
